export default __webpack_public_path__ + "static/media/imagen_login.477601b6.png";